import { CrudFormView, PageContainer } from '@startupquickstart/frontend';
import { useNavigate, useParams } from 'react-router-dom';
import { themeTypeCrudConfig, type ThemeType } from '@/config/objects/theme-types';

export function ThemeTypeFormPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const itemId = id === 'new' ? undefined : id;
  const isEdit = !!itemId;

  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Theme Types', href: '/theme-types' },
    { label: isEdit ? 'Edit Theme Type' : 'Create Theme Type', current: true },
  ];

  const handleSuccess = (item: ThemeType) => {
    navigate(`/theme-types/${item.id}`);
  };

  return (
    <PageContainer>
      <CrudFormView
        config={themeTypeCrudConfig}
        itemId={itemId}
        breadcrumbs={breadcrumbs}
        onSuccess={handleSuccess}
      />
    </PageContainer>
  );
}
